<template>
  <div :style='config.InnerStyle'>{{value?value.substr(0,16):'-'}}</div>
</template>
<script>
import base from "matrix.node.ui/field.js";
export default {
  mixins: [base.view(String)],
};
</script>